import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

/** Routes /app to trainer dashboard or client portal based on role. */
export default function DashboardRouter() {
  const { user, loading } = useAuth();
  if (loading || user === null)
    return <div className="min-h-screen grid place-items-center text-zinc-500 text-xs uppercase tracking-[0.3em]">Loading</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "client") return <Navigate to={`/app/clients/${user.id}`} replace />;
  return <Navigate to="/app/clients" replace />;
}
